import { useState, useEffect } from 'react';

const normalizarTiempo = (valor) => {
  const numero = Number(valor);

  if (!Number.isFinite(numero) || numero <= 0) {
    return 0;
  }

  return Math.floor(numero);
};

// Hook personalizado para manejar el temporizador del quiz
const useQuizTimer = (tiempoInicial, temporizadorActivo, onTiempoAgotado, onTemporizadorCambio, resetKey = null) => {
  const tiempoInicialNormalizado = normalizarTiempo(tiempoInicial);
  const [tiempoRestante, setTiempoRestante] = useState(tiempoInicialNormalizado);

  useEffect(() => {
    setTiempoRestante(tiempoInicialNormalizado);

    if (tiempoInicialNormalizado === 0 && temporizadorActivo && onTemporizadorCambio) {
      onTemporizadorCambio(false);
    }
  }, [tiempoInicialNormalizado, resetKey, temporizadorActivo, onTemporizadorCambio]);

  useEffect(() => {
    if (tiempoInicialNormalizado > 0 && tiempoRestante > tiempoInicialNormalizado) {
      setTiempoRestante(tiempoInicialNormalizado);
    }
  }, [tiempoInicialNormalizado, tiempoRestante]);

  useEffect(() => {
    let interval = null;

    if (tiempoInicialNormalizado <= 0) {
      if (tiempoRestante !== 0) {
        setTiempoRestante(0);
      }

      if (temporizadorActivo && onTemporizadorCambio) {
        onTemporizadorCambio(false);
      }

      return () => {};
    }

    if (temporizadorActivo && tiempoRestante > 0) {
      interval = setInterval(() => {
        setTiempoRestante(tiempo => {
          if (tiempo <= 1) {
            clearInterval(interval);
            if (onTemporizadorCambio) onTemporizadorCambio(false);
            if (onTiempoAgotado) onTiempoAgotado();
            return 0;
          }
          return tiempo - 1;
        });
      }, 1000);
    } else if (tiempoRestante <= 0 && temporizadorActivo) {
      if (onTemporizadorCambio) onTemporizadorCambio(false);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [temporizadorActivo, tiempoRestante, onTiempoAgotado, onTemporizadorCambio, tiempoInicialNormalizado]);

  const reiniciarTemporizador = (nuevoTiempo, activarTemporizador = false) => {
    const tiempoReinicio = typeof nuevoTiempo === 'number'
      ? normalizarTiempo(nuevoTiempo)
      : tiempoInicialNormalizado;

    setTiempoRestante(tiempoReinicio);

    if (onTemporizadorCambio) {
      onTemporizadorCambio(activarTemporizador && tiempoReinicio > 0);
    }
  };

  const pausarTemporizador = () => {
    if (onTemporizadorCambio) onTemporizadorCambio(false);
  };

  const reanudarTemporizador = () => {
    if (onTemporizadorCambio) onTemporizadorCambio(true);
  };

  return {
    tiempoRestante,
    reiniciarTemporizador,
    pausarTemporizador,
    reanudarTemporizador
  };
};

export default useQuizTimer;
